<template>
  <task-list-view type="done" />
</template>

<script>
import TaskListView from './components/TaskListView.vue'

export default {
  name: 'WflowDone',
  components: { TaskListView }
}
</script>
